function capitalize(str) {
  return str.split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

class BtnUpload extends HTMLElement {
  constructor() {
    super();
    this.uploadKitEv = new Event('adduploadkit');
    this.inputs = {};
    this.onWaitUploadKit();

    this.addEventListener('adduploadkit', () => {
      this.querySelectorAll('.uploadkit-button').forEach((btn) => {
        let proName = btn.dataset['uploaderName'] || 'Pet Photo';
        const wrap = document.createElement('div');
        wrap.classList.add('pet_name_wrap');
        const label = document.createElement('label');
        label.textContent = "Pet's Name";
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('class', 'pet-name');
        input.setAttribute('name', `properties[_${proName}_petName]`);
        input.setAttribute('placeholder', 'e.g. Bella, Bruno, Luna');
        input.setAttribute('value', '');
        wrap.appendChild(label);
        wrap.appendChild(input);
        btn.after(wrap);
        let property = JSON.parse(`{"_${proName}":"","_${proName} (direct link)":"","_${proName}_petName":""}`);
        this.inputs.properties = { ...this.inputs.properties, ...property };
      });
    });
  }

  onWaitUploadKit() {
    let interval = setInterval(() => {
      if (this.querySelector('.uploadkit-button')) {
        this.dispatchEvent(this.uploadKitEv);
        clearInterval(interval);
      }
    }, 500);
  }
}
customElements.define('upload-btn-wrapper', BtnUpload);

class BtnBefore extends HTMLElement {
  constructor() {
    super();
    this.beforeEv = new Event('before', { bubbles: true });
    this.addEventListener('click', e => { e.preventDefault(); this.dispatchEvent(this.beforeEv); });
  }
}
customElements.define('before-btn', BtnBefore);

class BtnNext extends HTMLElement {
  constructor() {
    super();
    this.nextEv = new Event('next', { bubbles: true });
    this.addEventListener('click', e => { e.preventDefault(); this.dispatchEvent(this.nextEv); });
  }
}
customElements.define('next-btn', BtnNext);

class OptionItem extends HTMLElement {
  constructor() {
    super();
    this.selectEv = new Event('selectopt', { bubbles: true });
    this.addEventListener('click', this.onSelectOption.bind(this));
  }

  connectedCallback() {
    this.v_option = this.dataset['v_option'];
    this.optionGroup = this.closest('[data-step]');
  }

  onSelectOption() {
    const group = this.optionGroup || this.closest('[data-step]');
    if (!group) return;
    group.querySelectorAll('option-item').forEach(item => item.classList.remove('selected'));
    this.classList.add('selected');
    setTimeout(() => this.dispatchEvent(this.selectEv), 150);
  }
}
customElements.define('option-item', OptionItem);

class ExtraAdd extends HTMLElement {
  constructor() {
    super();
    this.addExtraEv = new Event('addextra', { bubbles: true });
    this.removeExtraEv = new Event('removeextra', { bubbles: true });
    this.addEventListener('click', this.updateState.bind(this));
  }

  updateState(ev) {
    ev.preventDefault();
    if (this.classList.contains('added')) {
      this.classList.remove('added');
      this.dispatchEvent(this.removeExtraEv);
    } else {
      this.classList.add('added');
      this.dispatchEvent(this.addExtraEv);
    }
  }
}
customElements.define('extra-add', ExtraAdd);

class StepBlock extends HTMLElement {
  constructor() {
    super();

    this.url = new URL(window.location.href);
    this.product = JSON.parse(document.querySelector('#step-block-product').textContent);

    // Steps: pets is UI only navigation, size is the only real variant
    this.steps = ['number of pets', 'size', 'frame', 'background color', 'upload', 'extra'];

    // Pet count to product URL mapping
    this.petProducts = {
      '1 Pet': '/products/modern-hand-drawn-pet-portrait',
      '2 Pets': '/products/modern-hand-drawn-pet-portrait-2-pets',
      '3 Pets': '/products/modern-hand-drawn-pet-portrait-3-pets',
      '4 Pets': '/products/modern-hand-drawn-pet-portrait-4-pets'
    };

    // Which pet count this product represents (set via data attribute on step-block)
    this.petCount = parseInt(this.getAttribute('pet-count') || '1');

    this.selectedBgColor = null;
    this.selectedFrame = null;
    this.petPrices = null;
    this.petBasePrice = null;

    // Hero image and price for each pet count. Each count is a separate
    // product, so the 2-pet artwork does not exist in this product's own
    // media and cannot be found by index. Supplied by Liquid via pet-data
    // if present, otherwise fetched in loadPetPrices().
    this.petData = {};
    try {
      const raw = this.getAttribute('pet-data');
      if (raw) JSON.parse(raw).forEach(d => { this.petData[d.count] = d; });
    } catch (e) {
      console.error('Could not parse pet-data', e);
    }

    this.bgColorMap = {
      'White': 0, 'Yellow': 1, 'Violet': 2, 'Sage': 3,
      'Red': 4, 'Rainbow': 5, 'Purple': 6, 'Pink': 7,
      'Orange': 8, 'Navy Blue': 9, 'Light Blue': 10, 'Green': 11,
      'Chestnut': 12, 'Blue': 13, 'Black': 14, 'Apricot': 15
    };

    // Current variant. Only Size variants exist now
    let curVariantID = this.url.searchParams.get("variant");
    this.cur_variant = (curVariantID && this.product.variants.find(v => v.id == curVariantID))
      || this.product.variants.find(v => v.available)
      || this.product.variants[0];

    this.cur_options = this.cur_variant.options.join();

    // Pre-select size in UI
    this.product.options.forEach((optName, i) => {
      document.querySelectorAll(`[data-step="${optName}"] option-item`).forEach(item => {
        item.classList.toggle('selected', item.dataset['v_option'] == this.cur_variant.options[i]);
      });
    });

    // Sync the pets step highlight to the product we are actually on.
    // The Liquid marks "1 Pet" selected on every pet product, so without
    // this the 4-pets page shows 1 Pet highlighted next to a 4-pet price.
    const petLabel = this.petCount === 1 ? '1 Pet' : `${this.petCount} Pets`;
    this.querySelectorAll('[data-step="Number of Pets"] option-item').forEach(item => {
      item.classList.toggle('selected', item.dataset['v_option'] === petLabel);
    });

    this.dataset['v_id'] = this.cur_variant.id;

    if (!this.url.searchParams.get("variant")) {
      this.url.searchParams.set("variant", this.cur_variant.id);
      window.history.replaceState({}, "", this.url);
    }

    this.items = [{
      id: this.cur_variant.id,
      quantity: 1,
      price: this.cur_variant.price,
      properties: { '__step-product': true }
    }];

    this.addCartEv = new Event('customaddcart', { bubbles: true });
    this.beforeBtn = this.querySelector('before-btn');
    this.nextBtn = this.querySelector('next-btn');
    this.addCartBtn = this.querySelector('.atc-btn');
    this.uploadWrap = this.querySelector('upload-btn-wrapper');

    // Move UploadKit into our upload step once it renders
    const moveUploadKit = () => {
      const ukDiv = document.querySelector('.uploadkit.uploadkit-injected');
      const target = this.querySelector('upload-btn-wrapper');
      if (ukDiv && target && !target.contains(ukDiv)) {
        target.appendChild(ukDiv);
        clearInterval(ukInterval);
      }
    };
    const ukInterval = setInterval(moveUploadKit, 300);
    setTimeout(() => clearInterval(ukInterval), 10000);

    // Jump to step from URL param (used when navigating from pets step)
    const stepParam = parseInt(this.url.searchParams.get('step') || '0');
    this.setStep(stepParam, false);
    this.addActions();
    this.updateExtraPrices();
    this.updateSubTotal();
    this.loadPetPrices();

    // Force gallery to show first lifestyle image on load
    setTimeout(() => {
      const img = document.querySelector('.product-media__image');
      const firstMedia = this.product.media?.[0];
      if (img && firstMedia) {
        const baseUrl = firstMedia.src.split('?')[0];
        img.src = `${baseUrl}?width=3840`;
        img.srcset = '';
      }
    }, 100);
  }

  /* ------------------------------------------------------------------
     Currency helpers

     Liquid renders #step-block-product and the frame data attributes in
     the buyer's presentment currency already, so no conversion is needed.
     Only the currency SYMBOL was ever wrong. Everything routes through
     formatMoney so if that assumption changes there is one place to fix.
  ------------------------------------------------------------------ */

  get currencyCode() {
    return window.Shopify?.currency?.active || 'USD';
  }

  get currencyRate() {
    return parseFloat(window.Shopify?.currency?.rate || '1');
  }

  toPresentment(cents) {
    return parseInt(cents) || 0;
  }

  formatPresentment(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.currencyCode
      }).format(cents / 100);
    } catch (e) {
      // Unknown currency code, fall back to a plain number
      return (cents / 100).toFixed(2);
    }
  }

  formatMoney(cents) {
    return this.formatPresentment(this.toPresentment(cents));
  }

  addActions() {
    this.addEventListener('selectopt', this.onSelectOption.bind(this));
    this.addEventListener('before', this.onBeforeStep.bind(this));
    this.addEventListener('next', this.onNextStep.bind(this));
    this.addEventListener('addextra', this.onAddExtra.bind(this));
    this.addEventListener('removeextra', this.onRemoveExtra.bind(this));
    this.addEventListener('customaddcart', this.onAddCart.bind(this));
    this.addCartBtn?.addEventListener('click', () => this.dispatchEvent(this.addCartEv));
  }

  async loadPetPrices() {
    // Prefer pet-data from Liquid. Fall back to fetching the four products.
    if (!Object.keys(this.petData).length) {
      const labels = ['1 Pet', '2 Pets', '3 Pets', '4 Pets'];
      try {
        const results = await Promise.all(
          labels.map((label, i) =>
            fetch(this.petProducts[label] + '.js')
              .then(r => r.json())
              .then(d => ({
                count: i + 1,
                price: Math.min(...d.variants.map(v => v.price)),
                compare_at: d.compare_at_price || 0,
                image: d.featured_image
                  ? (d.featured_image.startsWith('//') ? 'https:' + d.featured_image : d.featured_image)
                  : null
              }))
          )
        );
        results.forEach(d => { this.petData[d.count] = d; });
      } catch (e) {
        console.error('Could not load pet data', e);
        return;
      }
    }

    // Preload hero images so switching feels instant
    Object.values(this.petData).forEach(d => {
      if (d.image) { const pre = new Image(); pre.src = d.image; }
    });

    this.petPrices = {};
    Object.values(this.petData).forEach(d => {
      this.petPrices[d.count === 1 ? '1 Pet' : `${d.count} Pets`] = d.price;
    });

    const basePrice = this.petData[1]?.price;
    if (basePrice) {
      this.petBasePrice = basePrice;
      this.querySelectorAll('[data-step="Number of Pets"] option-item').forEach(item => {
        const price = this.petPrices[item.dataset['v_option']];
        if (price === undefined) return;
        const delta = price - basePrice;
        const priceEl = item.querySelector('.option-price-delta');
        if (priceEl) priceEl.textContent = delta > 0 ? `+${this.formatMoney(delta)}` : '';
      });
    }

    this.updateSubTotal();
  }

  isDigitalDownload() {
    const sizeIndex = this.product.options.findIndex(o => o === 'Size');
    if (sizeIndex === -1) return false;
    return this.cur_variant.options[sizeIndex] === 'Digital Download';
  }

  getCurrentSize() {
    const sizeIndex = this.product.options.findIndex(o => o === 'Size');
    if (sizeIndex === -1) return null;
    const size = this.cur_variant.options[sizeIndex];
    return size.replace(/"/g, '').replace(/ x /g, 'x').replace(/ /g, '');
  }

  updateGallery() {
    if (!this.selectedBgColor) return;
    const slideIndex = this.bgColorMap[this.selectedBgColor];
    if (slideIndex !== undefined) {
      const slideshow = document.querySelector('slideshow-component');
      if (slideshow) slideshow.select(slideIndex);
    }
  }

  onSelectOption(ev) {
    const cur_index = parseInt(this.dataset.index);
    const value = ev.target.v_option;

    // Pets step: swap hero image and "From" price in place. No navigation.
    // The customer confirms with Continue, which onNextStep handles.
    if (this.steps[cur_index] === 'number of pets') {
      const count = parseInt(value) || 1;
      const data = this.petData[count];

      this.renderPetsFromPrice();

      const img = document.querySelector('.product-media__image');
      if (img && data && data.image) {
        img.src = data.image;
        img.srcset = '';
      }
      return;
    }

    if (this.steps[cur_index] === 'frame') {
      this.onSelectFrame(ev.target);
      return;
    }

    if (this.steps[cur_index] === 'background color') {
      this.selectedBgColor = value;
      this.items[0].properties['Background Color'] = value;
      this.updateGallery();
      return;
    }

    // Size step, index 0 in product options
    this.updateVariant(0, value);
  }

  onSelectFrame(el) {
    const frameName = el.dataset['frameName'];
    const size = this.getCurrentSize();
    const notice = this.querySelector('.frame-unavailable-notice');

    if (!frameName || frameName === 'No Frame') {
      this.selectedFrame = null;
      this.items = this.items.filter(i => !i._isFrame);
      if (notice) notice.style.display = 'none';
      this.updateSubTotal();
      this.updateDigitalDownloadUI();
      return;
    }

    const unavailable = el.dataset['frameSizesUnavailable'];
    if (unavailable) {
      const unavailableSizes = JSON.parse(unavailable);
      if (unavailableSizes.includes(size)) {
        if (notice) notice.style.display = 'block';
        this.querySelector('[data-frame-name="No Frame"]')?.classList.add('selected');
        el.classList.remove('selected');
        return;
      }
    }
    if (notice) notice.style.display = 'none';

    const variants = JSON.parse(el.dataset['frameVariants'] || '{}');
    const prices = JSON.parse(el.dataset['framePrices'] || '{}');
    const variantId = variants[size];
    const price = prices[size];

    if (!variantId) {
      if (notice) notice.style.display = 'block';
      return;
    }

    this.items = this.items.filter(i => !i._isFrame);
    this.selectedFrame = { variantId, price, name: frameName };
    this.items.push({ id: variantId, quantity: 1, price: price, _isFrame: true });
    this.updateSubTotal();
    this.updateDigitalDownloadUI();
  }

  onBeforeStep(ev) {
    const index = parseInt(ev.target.dataset['index']);
    let prev = index - 1;

    // Going back from step 1 (size) returns to pet selection.
    // Use the pet count of the CURRENT product so a 3-pet customer
    // is not silently dumped onto the 1-pet product.
    if (prev === 0) {
      const label = this.petCount === 1 ? '1 Pet' : `${this.petCount} Pets`;
      const url = this.petProducts[label] || this.petProducts['1 Pet'];
      window.location.href = url + '?step=0';
      return;
    }

    if (prev === 2 && this.isDigitalDownload()) prev = 1;

    if (index === 2 || (index === 3 && this.isDigitalDownload())) {
      this.selectedFrame = null;
      this.items = this.items.filter(i => !i._isFrame);
      this.querySelectorAll('[data-step="Frame"] option-item').forEach(el => el.classList.remove('selected'));
      const noFrame = this.querySelector('[data-frame-name="No Frame"]');
      if (noFrame) noFrame.classList.add('selected');
      this.updateSubTotal();
    }

    this.setStep(Math.max(prev, 0));
  }

  onNextStep(ev) {
    const index = parseInt(ev.target.dataset['index']);
    const current = this.steps[index];
    const limit = this.steps.length - 1;

    // Pets step: navigate to the selected product, or just advance
    // if the customer is already on the right one
    if (current === 'number of pets') {
      const selectedPet = this.querySelector('[data-step="Number of Pets"] option-item.selected');
      const petValue = selectedPet?.dataset?.['v_option'];
      const selectedCount = parseInt(petValue) || 1;

      if (selectedCount === this.petCount) {
        this.setStep(Math.min(index + 1, limit));
        return;
      }

      const url = this.petProducts[petValue];
      if (url) window.location.href = url + '?step=1';
      return;
    }

    if (current === 'frame') {
      const notice = this.querySelector('.frame-unavailable-notice');
      if (notice && notice.style.display === 'block') return;
    }

    if (current === 'upload') {
      let validated = true;
      const imageAttrContainers = this.querySelectorAll('.uploadkit-attribute-container');
      if (window.UploadKit && imageAttrContainers.length > 0) {
        imageAttrContainers.forEach(c => { if (c.innerHTML === '') validated = false; });
      }
      if (this.uploadWrap) {
        Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });
        this.uploadWrap.querySelectorAll('input').forEach(input => {
          let key = input.name.replace('properties[', '').replace(']', '');
          this.items[0].properties[key] = input.value;
        });
      }

      let nameValid = true;
      this.querySelectorAll('.pet-name').forEach(input => {
        if (input.value.trim() === '') {
          input.style.borderColor = '#fca5a5';
          nameValid = false;
        }
      });

      if (validated && nameValid) {
        this.setStep(Math.min(index + 1, limit));
      } else if (!validated) {
        this.showUploadError();
      } else if (!nameValid) {
        this.showNameError();
      }
      return;
    }

    let next = index + 1;
    if (next === 2 && this.isDigitalDownload()) next = 3;
    this.setStep(Math.min(next, limit));
  }

  showUploadError() {
    let err = this.querySelector('.upload-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'upload-error';
      err.textContent = 'Please upload a photo of your pet before continuing.';
      this.querySelector('upload-btn-wrapper')?.after(err);
    }
    err.style.display = 'block';
    setTimeout(() => { err.style.display = 'none'; }, 4000);
  }

  showNameError() {
    let err = this.querySelector('.name-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'name-error upload-error';
      err.textContent = "Please enter your pet's name before continuing.";
      this.querySelector('.pet-name')?.after(err);
    }
    err.style.display = 'block';
    setTimeout(() => {
      err.style.display = 'none';
      const nameInput = this.querySelector('.pet-name');
      if (nameInput) nameInput.style.borderColor = '';
    }, 4000);
  }

  setStep(index, scroll = true) {
    this.dataset['index'] = index;
    this.dataset['current'] = this.steps[index];

    [this.beforeBtn, this.nextBtn].forEach(btn => {
      if (!btn) return;
      btn.dataset['index'] = index;
      btn.dataset['current'] = this.steps[index];
    });

    this.querySelectorAll('.step-process').forEach((process, arg) => {
      process.classList.remove('active', 'current');
      if (arg === index) process.classList.add('current');
      else if (arg < index) process.classList.add('active');
    });

    this.querySelectorAll('.step-panel').forEach((panel, arg) => {
      panel.classList.toggle('visible', arg === index);
    });

    if (this.beforeBtn) {
      if (index === 0) {
        this.beforeBtn.style.visibility = 'hidden';
        this.beforeBtn.style.width = '0';
        this.beforeBtn.style.minWidth = '0';
        this.beforeBtn.style.padding = '0';
        this.beforeBtn.style.overflow = 'hidden';
        this.beforeBtn.style.border = 'none';
        this.beforeBtn.style.margin = '0';
      } else {
        this.beforeBtn.style.visibility = 'visible';
        this.beforeBtn.style.width = '';
        this.beforeBtn.style.minWidth = '';
        this.beforeBtn.style.padding = '';
        this.beforeBtn.style.overflow = '';
        this.beforeBtn.style.border = '';
        this.beforeBtn.style.margin = '';
      }
    }

    const isLastStep = this.steps[index] === 'extra';
    if (this.nextBtn) this.nextBtn.style.display = isLastStep ? 'none' : '';
    if (this.addCartBtn) this.addCartBtn.style.display = isLastStep ? '' : 'none';

    if (this.steps[index] === 'frame') this.updateFrameOptions();
    if (this.steps[index] === 'extra') this.updateExtraPrices();

    this.updateDigitalDownloadUI();

    // Refresh the price display: the pets step shows "From", every other
    // step shows the real running total
    this.updateSubTotal();

    // Only update size premiums on size step
    if (this.steps[index] === 'size') {
      const sizeOptionIndex = this.product.options.findIndex(o => o === 'Size');
      if (sizeOptionIndex !== -1) this.updatePremium(sizeOptionIndex);
    }

    if (scroll) {
      const rect = this.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight * 0.3) {
        const header = document.querySelector('.header') || document.querySelector('header');
        const headerH = header ? header.offsetHeight : 0;
        const top = window.scrollY + rect.top - headerH - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  }

  updateFrameOptions() {
    const size = this.getCurrentSize();

    this.querySelectorAll('[data-frame-name]').forEach(el => {
      const frameName = el.dataset['frameName'];
      if (!frameName || frameName === 'No Frame') return;

      const prices = JSON.parse(el.dataset['framePrices'] || '{}');
      const unavailable = el.dataset['frameSizesUnavailable'];
      const priceEl = el.querySelector('.option-price-delta');

      if (unavailable) {
        const unavailableSizes = JSON.parse(unavailable);
        if (unavailableSizes.includes(size)) {
          el.style.opacity = '0.4';
          el.style.pointerEvents = 'none';
          if (priceEl) priceEl.textContent = 'N/A for this size';
          return;
        }
      }

      el.style.opacity = '';
      el.style.pointerEvents = '';

      const price = prices[size];
      if (priceEl && price) {
        priceEl.textContent = `+${this.formatMoney(price)}`;
      }
    });
  }

  // Extras prices were rendered by Liquid and never passed through
  // formatMoney, so they stayed stuck on a literal "$" and could drift
  // out of sync with the variant price actually added to the cart.
  // Reading data-v_price guarantees the label matches what gets charged.
  updateExtraPrices() {
    this.querySelectorAll('extra-add').forEach(el => {
      const price = parseInt(el.dataset['v_price']);
      if (!price) return;
      const priceEl = el.querySelector('.option-price-delta, .extra-price');
      if (priceEl) priceEl.textContent = `+${this.formatMoney(price)}`;
    });
  }

  updateDigitalDownloadUI() {
    const isDigital = this.isDigitalDownload();

    // Fade frame step in progress bar when digital
    this.querySelectorAll('.step-process').forEach((dot, i) => {
      if (i === 2) {
        dot.style.opacity = isDigital ? '0.3' : '';
        dot.style.pointerEvents = isDigital ? 'none' : '';
      }
    });

    if (isDigital && this.selectedFrame) {
      this.selectedFrame = null;
      this.items = this.items.filter(i => !i._isFrame);
      this.querySelectorAll('[data-step="Frame"] option-item').forEach(el => el.classList.remove('selected'));
      const noFrame = this.querySelector('[data-frame-name="No Frame"]');
      if (noFrame) noFrame.classList.add('selected');
      this.updateSubTotal();
    }

    const framePanel = this.querySelector('[data-step-panel="2"]');
    if (framePanel) framePanel.style.display = '';

    this.querySelectorAll('[data-frame-only]').forEach(el => {
      el.classList.toggle('hidden', isDigital);
      if (isDigital && el.classList.contains('added')) {
        el.classList.remove('added');
        this.items = this.items.filter(item => item.id != el.dataset['v_id']);
        this.updateSubTotal();
      }
    });

    // Extras that are redundant once Digital Download is the chosen size.
    // Greyed out rather than hidden, so the customer can see they already
    // have it rather than wondering where the option went.
    this.querySelectorAll('[data-hide-when-digital]').forEach(el => {
      el.style.opacity = isDigital ? '0.4' : '';
      el.style.pointerEvents = isDigital ? 'none' : '';

      const desc = el.querySelector('.extra-desc');
      if (desc) {
        if (isDigital) {
          if (!desc.dataset.original) desc.dataset.original = desc.textContent;
          desc.textContent = 'Already included with your digital download.';
        } else if (desc.dataset.original) {
          desc.textContent = desc.dataset.original;
        }
      }

      // If they added it first and switched to digital afterwards,
      // take it back out of the total
      if (isDigital && el.classList.contains('added')) {
        el.classList.remove('added');
        this.items = this.items.filter(item => item.id != el.dataset['v_id']);
        this.updateSubTotal();
      }
    });
  }

  updatePremium(index) {
    const curOption = this.cur_variant.options;
    const optionName = this.product.options[index];

    const subVariants = this.product.variants.filter(variant => {
      for (let i = 0; i < curOption.length; i++) {
        if (i !== index && variant.options[i] !== curOption[i]) return false;
      }
      return true;
    });

    const basePrice = Math.min(...subVariants.map(v => v.price));

    let premiumPrices = {};
    subVariants.forEach(variant => {
      premiumPrices[variant.options[index]] = variant.price - basePrice;
    });

    const parent = document.querySelector(`[data-step="${optionName}"]`);
    if (!parent) return;

    parent.querySelectorAll('option-item').forEach(item => {
      const value = item.dataset['v_option'];
      const delta = premiumPrices[value] || 0;
      const priceEl = item.querySelector('.option-price-delta');
      if (priceEl) {
        priceEl.textContent = delta > 0 ? `+${this.formatMoney(delta)}` : '';
      }
    });
  }

  updateVariant(cur_index, value) {
    let cur_options = this.cur_options.split(',');
    let new_options = [...cur_options];
    new_options[cur_index] = value;

    let subVariants = this.product.variants.filter(v => v.options[cur_index] == value);

    for (let i = 0; i < cur_options.length; i++) {
      if (i !== cur_index) {
        const curSubVariants = subVariants.filter(v => v.options[i] == cur_options[i]);
        if (!curSubVariants.length) {
          const available = [...new Set(subVariants.map(v => v.options[i]))];
          new_options[i] = available[0];
          subVariants = subVariants.filter(v => v.options[i] == new_options[i]);
          const optName = this.product.options[i];
          document.querySelectorAll(`[data-step="${optName}"] option-item`).forEach(opt => {
            opt.classList.toggle('selected', opt.dataset['v_option'] == new_options[i]);
          });
        } else {
          subVariants = curSubVariants;
        }
      }
    }

    this.cur_variant = subVariants[0] || this.cur_variant;
    this.cur_options = new_options.join();

    this.url.searchParams.set("variant", this.cur_variant.id);
    window.history.replaceState({}, "", this.url);

    this.items[0].id = this.cur_variant.id;
    this.items[0].price = this.cur_variant.price;

    // Update frame variant if size changed
    if (this.selectedFrame) {
      const frameEl = this.querySelector(`[data-frame-name="${this.selectedFrame.name}"]`);
      if (frameEl) {
        const variants = JSON.parse(frameEl.dataset['frameVariants'] || '{}');
        const prices = JSON.parse(frameEl.dataset['framePrices'] || '{}');
        const newSize = this.getCurrentSize();
        const newVariantId = variants[newSize];
        const newPrice = prices[newSize];

        if (newVariantId) {
          this.items = this.items.filter(i => !i._isFrame);
          this.selectedFrame = { ...this.selectedFrame, variantId: newVariantId, price: newPrice };
          this.items.push({ id: newVariantId, quantity: 1, price: newPrice, _isFrame: true });
        } else {
          this.items = this.items.filter(i => !i._isFrame);
          this.selectedFrame = null;
          this.querySelector('[data-frame-name="No Frame"]')?.classList.add('selected');
          frameEl.classList.remove('selected');
        }
      }
    }

    if (this.uploadWrap) {
      Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });
    }

    this.updateGallery();
    this.updateSubTotal();
    this.updateDigitalDownloadUI();
  }

  onAddExtra(ev) {
    const v_id = parseInt(ev.target.dataset['v_id']);
    const v_price = parseInt(ev.target.dataset['v_price']);
    this.items.push({ id: v_id, quantity: 1, price: v_price });
    this.updateSubTotal();
  }

  onRemoveExtra(ev) {
    const v_id = ev.target.dataset['v_id'];
    this.items = this.items.filter(item => item.id != v_id);
    this.updateSubTotal();
  }

  // Nothing is configured on the pets step yet, so anchor on the cheapest
  // variant rather than whichever one happens to be first available
  renderPetsFromPrice() {
    const selected = this.querySelector('[data-step="Number of Pets"] option-item.selected');
    const label = selected?.dataset?.['v_option']
      || (this.petCount === 1 ? '1 Pet' : `${this.petCount} Pets`);
    const count = parseInt(label) || 1;
    const data = this.petData[count];

    const price = (data && data.price)
      || (this.petPrices && this.petPrices[label])
      || Math.min(...this.product.variants.map(v => v.price));

    const moneyEl = this.querySelector('.subtotal .money');
    if (moneyEl) moneyEl.textContent = `From ${this.formatMoney(price)}`;

    const compareEl = this.querySelector('.subtotal-compare');
    if (compareEl) {
      if (data && data.compare_at > price) {
        compareEl.textContent = this.formatMoney(data.compare_at);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    this.renderShipping(price);
  }

  renderShipping(total) {
    const shippingEl = this.querySelector('.step-freeshipping');
    if (!shippingEl) return;

    const thresholds = { 'USD': 12500, 'GBP': 10000, 'AUD': 20000, 'EUR': 12500, 'NZD': 20000, 'CAD': 17500 };
    const threshold = thresholds[this.currencyCode] || 12500;
    const presentTotal = this.toPresentment(total);

    if (presentTotal < threshold) {
      shippingEl.innerHTML = `<span>You're only <strong>${this.formatPresentment(threshold - presentTotal)}</strong> away from <strong>FREE SHIPPING</strong></span>`;
    } else {
      shippingEl.innerHTML = `<span>🎉 You've unlocked <strong>FREE SHIPPING</strong></span>`;
    }
  }

  updateSubTotal() {
    // On the pets step nothing is chosen yet, so show a "From" price instead
    if (this.steps[parseInt(this.dataset.index)] === 'number of pets') {
      this.renderPetsFromPrice();
      return;
    }

    const subTotal = this.items.reduce((sum, item) => sum + parseInt(item.price || 0), 0);

    try {
      const moneyEl = this.querySelector('.subtotal .money');
      if (moneyEl) moneyEl.textContent = this.formatMoney(subTotal);

      this.renderShipping(subTotal);

      const mainCompare = parseInt(this.cur_variant.compare_at_price) || 0;
      const mainPrice = parseInt(this.cur_variant.price) || 0;
      const compareEl = this.querySelector('.subtotal-compare');
      if (compareEl) {
        if (mainCompare > mainPrice) {
          const extrasTotal = this.items.slice(1).reduce((s, i) => s + parseInt(i.price || 0), 0);
          compareEl.textContent = this.formatMoney(mainCompare + extrasTotal);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  onAddCart() {
    const btn = this.querySelector('.atc-btn');
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }

    const mugVtId = this.getAttribute('mug-v_id');

    const items = this.items
      .filter(i => !i._isFrame)
      .concat(this.items.filter(i => i._isFrame).map(i => ({
        id: parseInt(i.id),
        quantity: i.quantity,
        price: parseInt(i.price),
        properties: { '_frame': this.selectedFrame?.name, '__step-product': true }
      })));

    if (!this.isDigitalDownload() && this.selectedFrame && mugVtId) {
      items.push({ id: parseInt(mugVtId), quantity: 1, price: 0 });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(res => res.json())
    .then(() => { window.location.href = '/checkout'; })
    .catch(err => {
      console.error(err);
      if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
    });
  }
}
customElements.define('step-block', StepBlock);